<section class="tw-relative tw-py-[50px] lg:tw-py-[100px]">
    <div
        class="content tw-relative tw-z-[2] tw-max-w-[1220px] tw-px-[28px] tw-mx-auto tw-flex tw-flex-col lg:tw-flex-row tw-gap-3"
    >
        <div class="md:tw-min-w-[370px] tw-ml-3 tw-flex-1">
            <h2
                data-sal="slide-right"
                data-sal-delay="500"
                data-sal-duration="1000"
                class="!tw-text-[20px] tw-text-center lg:!tw-mt-[120px] lg:tw-text-left sm:!tw-text-[30px] lg:!tw-text-[40px] !tw-font-bold !tw-text-[#0F3172] !tw-leading-[1.5]"
            >
                {{ "HOME.OUR_NATION_BUILDING" | translate }}
            </h2>
        </div>
        <div
            class="tw-flex-[2] tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-5 lg:tw-gap-2"
        >
            <div>
                <div
                    data-sal="slide-left"
                    data-sal-delay="500"
                    data-sal-duration="1000"
                    class="tw-relative tw-flex tw-flex-col tw-w-full tw-max-w-[319px] tw-mx-auto tw-h-[295px] lg:tw-h-[512px] lg:tw-max-w-[263px] tw-flex tw-items-end tw-rounded-[16px] tw-overflow-hidden tw-object-cover tw-object-right tw-cursor-pointer"
                    (click)="redirectOnClick('myknp')"
                >
                    <img
                        ga-event-id="myknp_card_homepage_click"
                        ga-event-category="Homepage Button"
                        ga-event-label="MyKNP Card Click"
                        ga-track="track"
                        src="/assets/images/home/img1.jpeg"
                        alt="Partnership"
                        class="tw-static tw-hidden lg:tw-block tw-left-0 tw-h-[59%] tw-w-full tw-top-0 tw-object-cover"
                    />
                    <img
                        ga-event-id="myknp_card_homepage_click"
                        ga-event-category="Homepage Button"
                        ga-event-label="MyKNP Card Click"
                        ga-track="track"
                        src="/assets/images/home/img1-mob.png"
                        alt="Partnership"
                        class="tw-absolute tw-block lg:tw-hidden tw-left-0 tw-h-full tw-w-full tw-top-0"
                    />
                    <div
                        class="tw-absolute tw-bottom-0 tw-w-full lg:tw-h-[210px] tw-p-4 xl:tw-bg-[#E5E5E5] xl:tw-shadow-[0_-13px_17px_8px_#E5E5E5] tw-h-[210px] tw-flex tw-flex-col tw-justify-end xl:tw-justify-start tw-bg-[linear-gradient(1deg,#e5e5e5_40%,#00000000_90%)]"
                    >
                        <h4
                            class="!tw-text-[20px] !tw-text-[#002D86] !tw-underline !tw-font-bold lg:tw-h-[48px]"
                        >
                            {{ "MYKNP" | translate }}
                        </h4>
                        <span class="tw-text-[14px] tw-text-[#2A2A2A]">
                            {{ "HOME.MYKNP_DESC" | translate }}
                        </span>
                    </div>
                </div>
            </div>
            <div>
                <div
                    data-sal="slide-left"
                    data-sal-delay="700"
                    data-sal-duration="1000"
                    class="tw-relative tw-flex tw-flex-col tw-w-full tw-max-w-[319px] tw-mx-auto tw-h-[295px] lg:tw-h-[512px] lg:tw-max-w-[263px] tw-flex tw-items-end tw-rounded-[16px] tw-overflow-hidden tw-cursor-pointer"
                    (click)="redirectOnClick('grants')"
                >
                    <img
                        ga-event-id="grants_card_homepage_click"
                        ga-event-category="Homepage Button"
                        ga-event-label="Grants Card Click"
                        ga-track="track"
                        src="/assets/images/home/img2.png"
                        alt="Partnership"
                        class="tw-static tw-hidden lg:tw-block tw-left-0 tw-h-[59%] tw-w-full tw-top-0"
                    />
                    <img
                        ga-event-id="grants_card_homepage_click"
                        ga-event-category="Homepage Button"
                        ga-event-label="Grants Card Click"
                        ga-track="track"
                        src="/assets/images/home/img2-mob.png"
                        alt="Partnership"
                        class="tw-absolute tw-block lg:tw-hidden tw-left-0 tw-h-[78%] lg:tw-h-full tw-w-full tw-top-0"
                    />
                    <div
                        class="tw-absolute tw-bottom-0 tw-w-full lg:tw-h-[210px] tw-p-4 xl:tw-bg-[#E5E5E5] xl:tw-shadow-[0_-13px_17px_8px_#E5E5E5] tw-h-[210px] tw-flex tw-flex-col tw-justify-end xl:tw-justify-start tw-bg-[linear-gradient(1deg,#e5e5e5_40%,#00000000_90%)]"
                    >
                        <h4
                            class="!tw-text-[20px] !tw-text-[#002D86] !tw-underline !tw-font-bold lg:tw-h-[48px]"
                        >
                            {{ "COMMON.GRANTS" | translate }}
                        </h4>
                        <span class="tw-text-[14px] tw-text-[#2A2A2A]">
                            {{ "HOME.GRANTS_DESC" | translate }}
                        </span>
                    </div>
                </div>
            </div>
            <div>
                <div
                    data-sal="slide-left"
                    data-sal-delay="900"
                    data-sal-duration="1000"
                    class="tw-relative tw-flex tw-flex-col tw-w-full tw-max-w-[319px] tw-mx-auto tw-h-[295px] lg:tw-h-[512px] lg:tw-max-w-[263px] tw-flex tw-items-end tw-rounded-[16px] tw-overflow-hidden tw-object-cover tw-object-right tw-cursor-pointer"
                    (click)="redirectOnClick('cgc-developmental-programme')"
                >
                    <img
                        ga-event-id="cgc_developmental_programme_card_homepage_click"
                        ga-event-category="Homepage Button"
                        ga-event-label="CGC Developmental Programme Card Click"
                        ga-track="track"
                        src="/assets/images/home/img3.jpeg"
                        alt="Partnership"
                        class="tw-static tw-hidden lg:tw-block tw-left-0 tw-h-[59%] tw-w-full tw-top-0 tw-object-cover"
                    />
                    <img
                        ga-event-id="cgc_developmental_programme_card_homepage_click"
                        ga-event-category="Homepage Button"
                        ga-event-label="CGC Developmental Programme Card Click"
                        ga-track="track"
                        src="/assets/images/home/img3-mob.png"
                        alt="Partnership"
                        class="tw-absolute tw-block lg:tw-hidden tw-left-0 tw-h-full tw-w-full tw-top-0"
                    />
                    <div
                        class="tw-absolute tw-bottom-0 tw-w-full lg:tw-h-[210px] tw-p-4 xl:tw-bg-[#E5E5E5] xl:tw-shadow-[0_-13px_17px_8px_#E5E5E5] tw-h-[210px] tw-flex tw-flex-col tw-justify-end xl:tw-justify-start tw-bg-[linear-gradient(1deg,#e5e5e5_40%,#00000000_90%)]"
                    >
                        <h4
                            class="!tw-text-[20px] !tw-text-[#002D86] !tw-underline !tw-font-bold lg:tw-h-[48px]"
                        >
                            {{ "COMMON.CGC_PROGRAMME" | translate }}
                        </h4>
                        <span class="tw-text-[14px] tw-text-[#2A2A2A]">
                            {{ "HOME.CGC_DEV_PROGRAMME_DESC" | translate }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <svg
        width="341"
        height="170"
        viewBox="0 0 341 170"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="tw-absolute tw-bottom-0 tw-left-[20%] tw-hidden lg:tw-block"
    >
        <circle
            cx="42.5"
            cy="42.5"
            r="42.5"
            fill="#2280D6"
            fill-opacity="0.65"
        />
        <path
            d="M6.9981 170C6.9981 77.7684 81.7665 2.99999 173.998 2.99999C266.23 3 340.998 77.7684 340.998 170L6.9981 170Z"
            fill="#F36F32"
            fill-opacity="0.65"
        />
    </svg>
</section>
